import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { Permissions } from '@app/core/guard/Permissions';
import { SupportDocumentDto } from '@interfaces/partner-income-tax/responses/partner-income-tax.response';
import { PermissionsService } from '@services/helpers/permissions.service';
import { PartnerIncomeTaxStateService } from '@features/dashboard/performance/pages/dfp/components/partner-income-tax/partner-income-tax-state.service';
import { buildFolderLink } from '@features/dashboard/performance/pages/dfp/components/partner-income-tax/partner-income-tax.constants';
import { DataRoomDocumentsComponent } from '@features/dashboard/performance/pages/dfp/components/partner-income-tax/components/data-room-documents/data-room-documents.component';

/** Frase dos documentos de suporte (matrículas, laudos...). */
export const SUPPORT_DOCS_NOTE =
  'Matrículas, laudos, certidões e extratos entram pelo Data Room da empresa e são ligados ao bem automaticamente.';

/**
 * Aba interna "Documentos": os documentos de suporte esperados do sócio (quando há) e o bloco "Declarações no Data
 * Room" com a leitura seletiva. No consolidado só o bloco (os documentos são da empresa).
 */
@Component({
  selector: 'app-pit-documents-section',
  standalone: true,
  imports: [DataRoomDocumentsComponent],
  templateUrl: './documents-section.component.html',
  styleUrl: './documents-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DocumentsSectionComponent {
  private readonly state = inject(PartnerIncomeTaxStateService);
  private readonly router = inject(Router);

  /** Documentos de suporte esperados do sócio (vazio no consolidado). */
  readonly supportDocuments = input<SupportDocumentDto[]>([]);

  protected readonly note = SUPPORT_DOCS_NOTE;

  /** Sem `DATAROOM_VIEW` o link da pasta some: a rota do Data Room recusaria. */
  protected readonly canOpenDataRoom = toSignal(
    inject(PermissionsService).hasPermission(Permissions.DataRoom.VIEW),
    { initialValue: false }
  );

  protected readonly folderLink = computed(() => {
    const overview = this.state.overview();
    return overview
      ? buildFolderLink(overview.companyId, overview.irpfFolderId, overview.partnerFolderId)
      : null;
  });

  protected readonly received = computed(() => {
    const docs = this.supportDocuments();
    return { received: docs.filter(doc => doc.status === 'recebido').length, total: docs.length };
  });

  protected openFolder(): void {
    const link = this.folderLink();
    if (link) this.router.navigate(link.route, { queryParams: link.queryParams ?? undefined });
  }
}
